module.exports = __webpack_public_path__ + "img/bridge2.8138d20a.png";